import type { AiCampaignForm, AiPreviewData } from '@/features/campaigns/types/campaign';

export type AIBuilderProps = {
  formData: AiCampaignForm;
  setFormData: React.Dispatch<React.SetStateAction<AiCampaignForm>>;
  onPreviewGenerated: (data: AiPreviewData) => void;
};

export const BUDGET_PRESETS = [500, 1000, 2500, 5000, 10000] as const;
